module.exports = __webpack_public_path__ + "img/40.7.Chla.100bd8bf.png";